module.exports = __webpack_public_path__ + "img/logo.136de902.svg";